import React, { useState, useRef, useContext } from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useApplicationProvider from "./useApplicationProvider";
import { ApplicationDataAPI } from "../API/ApplicationDataAPI";
import ApplicationContext from "./ApplicationContext";
import { DocsDataAPI } from "../API/DocsDataAPI";
import useAPIError from "../../../../src/common/lib/APIError";

import SearchAppContext from "../ApplicationQueue/searchedAppContext";

const useStyles = makeStyles((theme) => ({
	labelDesign: {
		fontSize: "0.75rem !important",
	},
}));
const ITEM_HEIGHT = 48;
export default function ActionButton({
	app,
	isUser,
	isAdminConsole,
	moveOpen,
	setMoveOpen,
	transferOpen,
	setTransferOpen,
	transferOptions,
	setTransferOptions,
	onAppOpen,
}) {
	const inputRef = useRef(null);
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const { toggleQueueDrawer } = useContext(ApplicationContext);
	const { onAppSelected } = useApplicationProvider();
	const { setSearchedQueue } = useContext(SearchAppContext);
	const [resubmitDetailsResponse, setResubmitDetailsResponse] = useState([]);

	const { addError, setLoader } = useAPIError();

	const setupTransferDeal = async () => {
		setTransferOpen(true);
		let groupNum = "";
		if (app?.status == "Verbal DnA") {
			groupNum = "1";
		}
		if (
			app?.status == "New" ||
			app?.status == "Submitted" ||
			app?.status == "Pre-Credit Review" ||
			app?.status == "Asset Review" ||
			app?.status == "Credit Review" ||
			app?.status == "Credit Adjudication" ||
			app?.status == "Dealmaker"
		) {
			groupNum = "2";
		}
		if (
			app?.status == "Document Data Review" ||
			app?.status == "Documents Sent" ||
			app?.status == "Document Check In" ||
			app?.status == "Funding" ||
			app?.status == "Funded" ||
			app?.status == "Booked"
		) {
			groupNum = "3";
		}
		let groupIdCode = "GRP" + groupNum;
		if (app?.Is_Premium && groupNum == "2") {
			groupIdCode = app?.broker_account_referral_agency_id;
		}
		if (app?.Is_Premium && groupNum == "3") {
			groupIdCode = "3A__" + app?.broker_account_referral_agency_id;
		}
		if (
			app?.is_discounted != undefined &&
			app?.is_discounted == "Yes" &&
			groupNum == "2"
		) {
			groupIdCode = "2B__" + app?.broker_account_referral_agency_id;
		}
		if (
			app?.is_discounted != undefined &&
			app?.is_discounted == "Yes" &&
			groupNum == "3"
		) {
			groupIdCode = "3B__" + app?.broker_account_referral_agency_id;
		}
		await ApplicationDataAPI.getUsersInfo(app?.id, groupIdCode).then(
			(response) => {
				let users = response.map((user) => ({
					id: user?.User_Id__r?.Id ?? "",
					name: user?.User_Id__r?.Name ?? "",
					details: user,
				}));
				setTransferOptions(users);
			}
		);
		// let options = [];
		// if (transferUsers[0]?.Round_Robin_User_Group__r) {
		// 	for (var i = 1; i < transferUsers.length; i++) {
		// 		if (
		// 			groupNum == "1" &&
		// 			transferUsers[i].User_Id__r.Id ==
		// 				transferUsers[0].Round_Robin_User_Group__r.Group1_User__c &&
		// 			transferUsers[0].Round_Robin_User_Group__r.Group1_User__c
		// 		) {
		// 			continue;
		// 		}
		// 		if (
		// 			groupNum == "2" &&
		// 			transferUsers[i].User_Id__r.Id ==
		// 				transferUsers[0].Round_Robin_User_Group__r.Group2_User__c &&
		// 			transferUsers[0].Round_Robin_User_Group__r.Group2_User__c
		// 		) {
		// 			continue;
		// 		}
		// 		if (
		// 			groupNum == "3" &&
		// 			transferUsers[i].User_Id__r.Id ==
		// 				transferUsers[0].Round_Robin_User_Group__r.Group3_User__c &&
		// 			transferUsers[0].Round_Robin_User_Group__r.Group3_User__c
		// 		) {
		// 			continue;
		// 		}

		// 		options.push({
		// 			id: transferUsers[i].User_Id__r.Id,
		// 			name: transferUsers[i].User_Id__r.Name,
		// 			details: transferUsers[i],
		// 		});
		// 	}
		// 	setTransferOptions(options);
		// }
	};

	const options = [
		{ name: "View", label: "View" },
		{ name: "Start Work", label: "Start Work" },
	];
	const adminConsoleOptions = [{ name: "View", label: "View" }];

	const lockOptions = [
		{ name: "View", label: "View" },
		{ name: "Unlock", label: `Unlock (${app.locked_by_name})` },
	];

	const lockByMeOptions =
		app?.status == "Credit Review" || app?.status == "Credit Adjudication"
			? [
					{ name: "Continue Work", label: "Continue Work" },
					{ name: "Unlock", label: `Unlock (${app.locked_by_name})` },
					{ name: "Move App to Asset Review", label: "Move App to Asset Review" },
					{ name: "Transfer Deal", label: "Transfer Deal" },
					{ name: "Done", label: "Done!" },
			  ]
			: app?.status == "Document Data Review" ||
			  app?.status == "Documents Sent" ||
			  app?.status == "Document Check In"
			? [
					{ name: "Continue Work", label: "Continue Work" },
					{ name: "Unlock", label: `Unlock (${app.locked_by_name})` },
					{ name: "Move App to DealMaker", label: "Move App to DealMaker" },
					{ name: "Transfer Deal", label: "Transfer Deal" },
					{ name: "Done", label: "Done!" },
			  ]
			: [
					{ name: "Continue Work", label: "Continue Work" },
					{ name: "Unlock", label: `Unlock (${app.locked_by_name})` },
					{ name: "Transfer Deal", label: "Transfer Deal" },
					{ name: "Done", label: "Done!" },
			  ];

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const validateUnSatisfiedItems = async () => {
		let fundingChecklistResponse = await DocsDataAPI.getFundingChecklistResps(
			app.id,
			app.locked_by_email
		);

		const visibleItems = fundingChecklistResponse.filter(
			(item) => item.is_visible === true
		);

		visibleItems.sort((a, b) => a.order - b.order);

		const REQUIRED = ["Yes", "", null, undefined];
		const STATUS = ["Open", "Pending Review", "", null, undefined];

		for (const item of visibleItems) {
			const isRequiredUnSatisfied = REQUIRED.includes(item.required);
			const isStatusUnSatisfied = STATUS.includes(item.status);

			if (isRequiredUnSatisfied && isStatusUnSatisfied) {
				return true;
			}
		}

		return false;
	};

	const validateResubmitItems = async () => {
		try {
			let ResubmitDetailsResponse = await ApplicationDataAPI.fetchResubmit(
				app.id,
				app.locked_by_email
			);

			if (ResubmitDetailsResponse && ResubmitDetailsResponse.length >= 1) {
				// Sort by date here... resubmit_decision_date
				let sortedResponse = ResubmitDetailsResponse.sort((a, b) => {
					const dateA = new Date(a.resubmit_decision_date);
					const dateB = new Date(b.resubmit_decision_date);
					return dateB - dateA;
				});

				if (
					!sortedResponse[0].resubmit_analyst_notes ||
					!(
						sortedResponse[0].resubmit_decision === "Approved" ||
						sortedResponse[0].resubmit_decision === "Declined"
					) ||
					!sortedResponse[0].resubmit_sent_queue
				) {
					return true; // Missing required data, return true
				} else {
				
					let resubmit_sent_queue;

					switch (sortedResponse[0].resubmit_sent_queue) {
						case "DealMaker":
							resubmit_sent_queue = "DealMaker";
							break;
						case "Document Data Review":
							resubmit_sent_queue = "DocDataReview";
							break;
						case "Documents Sent":
							resubmit_sent_queue = "DocSent";
							break;
						case "Document Review":
							resubmit_sent_queue = "DocReview";
							break;
						case "Verbal":
							resubmit_sent_queue = "Verbal";
							break;
						case "Funding":
							resubmit_sent_queue = "Funding";
							break;
					}

					let putResubmitResponse = await ApplicationDataAPI.putResubmit(
						app.id,
						app.locked_by_email,
						resubmit_sent_queue
					);

					return false;

				}
			} else {
				return true; // No data found, return true
			}
		} catch (error) {
			console.log(error);
		}

		return true; // Error occurred, return true
	};

	const handleClose = async (option) => {
		setSearchedQueue("");

		const resubmitFlag = document.title === "RESUBMIT";

		const checklistFlag =
			document.title === "DEAL REVIEW" ||
			document.title === "DOCUMENT DATA REVIEW" ||
			document.title === "DOCUMENTS SENT" ||
			document.title === "DOCUMENT REVIEW" ||
			document.title === "FUNDING REVIEW" ||
			document.title === "FUNDING CONFIRMATION" ||
			document.title === "PRE-DELIVERY";

		setAnchorEl(null);
		if (!option) return;

		let checklistResult = false;
		let resubmitResult = false;

		if (option.action === "Done" && checklistFlag === true) {
			checklistResult = await validateUnSatisfiedItems();
		}

		if (option.action === "Done" && resubmitFlag === true) {
			resubmitResult = await validateResubmitItems();
		}

		if (checklistResult === true) {
			addError("Required checklist items have not been satisfied");
			return;
		} else if (resubmitResult === true) {
			addError("Required resubmit items have not been satisfied");
			return;
		} else {

			if (option.action === "Done" && resubmitFlag === true) {
				window.location.reload();
			} else {

				if (
					(option.action == "Move App to Asset Review" ||
						option.action == "Move App to DealMaker") &&
					setMoveOpen
				) {
					setMoveOpen(true);
				} else if (option.action == "Transfer Deal") {
					setupTransferDeal();
				} else {
					if (onAppOpen) {
						onAppOpen();
					}
					onAppSelected(option, app);
				}
				toggleQueueDrawer(false);

			}


		}
	};

	return (
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				size="small"
				onClick={handleClick}>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="long-menu"
				ref={inputRef}
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={() => handleClose()}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: "23ch",
					},
				}}>
				{isAdminConsole
					? adminConsoleOptions.map((option, index) => (
							<MenuItem
								style={{ fontSize: "0.75rem !important" }}
								key={index}
								onClick={() => {
									handleClose({ action: option.name });
								}}>
								<Typography className={classes.labelDesign} variant="inherit" noWrap>
									{option.label}
								</Typography>
							</MenuItem>
					  ))
					: app.is_locked
					? isUser
						? lockByMeOptions.map((option, index) => (
								<MenuItem
									key={index}
									style={{ fontSize: "0.75rem !important" }}
									onClick={() => {
										handleClose({ action: option.name });
									}}>
									<Typography className={classes.labelDesign} variant="inherit" noWrap>
										{option.label}
									</Typography>
								</MenuItem>
						  ))
						: lockOptions.map((option, index) => (
								<MenuItem
									key={index}
									style={{ fontSize: "0.75rem !important" }}
									onClick={() => {
										handleClose({ action: option.name });
									}}>
									<Typography className={classes.labelDesign} variant="inherit" noWrap>
										{option.label}
									</Typography>
								</MenuItem>
						  ))
					: options.map((option, index) => (
							<MenuItem
								key={index}
								style={{ fontSize: "0.75rem !important" }}
								onClick={() => {
									handleClose({ action: option.name });
								}}>
								<Typography className={classes.labelDesign} variant="inherit" noWrap>
									{option.label}
								</Typography>
							</MenuItem>
					  ))}
			</Menu>
		</div>
	);
}

ActionButton.propTypes = {
	app: PropTypes.object.isRequired,
	isUser: PropTypes.bool.isRequired,
};
export const getCurrentGroupOrder = (appStatus) => {
	if (appStatus === "Verbal DnA") return 1;
	else if (
		appStatus === "New" ||
		appStatus === "Submitted" ||
		appStatus === "Pre-Credit Review" ||
		appStatus === "Asset Review" ||
		appStatus === "Credit Review" ||
		appStatus === "Credit Adjudication" ||
		appStatus === "Dealmaker"
	)
		return 2;
	else if (
		appStatus === "Document Data Review" ||
		appStatus === "Documents Sent" ||
		appStatus === "Document Check In" ||
		appStatus === "Funding" ||
		appStatus === "Funded" ||
		appStatus == "Booked"
	)
		return 3;
	else return 0;
};
